import HomeWeeklyFlightsDetails from './HomeWeeklyFlightsDetails';
export default HomeWeeklyFlightsDetails;
